// moduleIndex - index - permission
import { PageURLs } from '@/utils/navigate';

export const PERMISSION = {
  '1-2-1': '',
  '1-2-3': 'Quyền vô hiệu hoá tài khoản người dùng',
  '1-2-4': '',
  '1-3-1': '',
  '4-5-1': '',
  '4-5-2': '',
  '4-5-3': '',
  '4-5-4': '',
  '4-6-1': '',
  '4-6-2': '',
  '4-6-3': '',
  '4-6-4': '',
  '4-7-1': '',
  '8-9-1': '',
  '8-9-2': '',
  '8-9-3': '',
  '8-9-4': '',
  '8-10-1': '',
  '8-10-2': '',
  '8-10-3': '',
  '8-10-4': '',
  '11-12-1': '',
  '11-12-2': '',
  '11-12-3': '',
  '11-12-4': '',
  '11-13-1': '',
  '11-13-2': '',
  '11-13-3': '',
  '11-25-1': '',
  '11-25-2': '',
  '11-25-3': '',
  '11-25-4': '',
  '14-15-1': '',
  '14-15-2': '',
  '14-15-3': '',
  '14-15-4': '',
  '14-16-1': '',
  '14-16-2': '',
  '14-16-3': '',
  '14-16-4': '',
  '14-16-5': '',
  '14-17-1': '',
  '14-17-2': '',
  '14-17-3': '',
  '14-17-4': '',
  '14-18-1': '',
  '14-18-2': '',
  '14-18-3': '',
  '14-18-4': '',
  '14-19-1': '',
  '14-19-2': '',
  '14-19-3': '',
  '14-19-4': '',
  '14-20-1': '',
  '14-20-2': '',
  '14-20-3': '',
  '14-20-4': '',
  '14-21-1': '',
  '14-21-2': '',
  '14-21-3': '',
  '14-21-4': '',
  '14-21-5': '',
  '14-22-1': '',
  '14-22-2': '',
  '14-22-3': '',
  '14-22-4': '',
  '14-22-5': '',
  '14-23-1': '',
  '14-23-2': '',
  '14-23-3': '',
  '14-23-4': '',
  '26-27-1': '',
  '26-27-2': '',
  '26-27-3': '',
  '26-27-4': '',
  '26-28-1': '',
  '26-28-2': '',
  '26-28-3': '',
  '26-28-4': '',
  '15-24-1': 'Quyền xem thông báo',
  '15-24-2': 'Quyền tạo thông báo',
  '15-24-3': 'Quyền sửa thông báo',
  '15-24-4': 'Quyền xóa thông báo'
};

export const PERMISSION_BY_KEY = {
  '1-2-1': PageURLs.ofUsersManagement(),
  '1-2-3': PageURLs.ofUsersManagement(),
  '1-2-4': PageURLs.ofUsersManagement(),
  '1-3-1': PageURLs.ofUsersActivity(),
  '4-5-1': PageURLs.ofAdminManagement(),
  '4-5-2': PageURLs.ofAdminManagement(),
  '4-5-3': PageURLs.ofAdminManagement(),
  '4-5-4': PageURLs.ofAdminManagement(),
  '4-6-1': PageURLs.ofRoleManagement(),
  '4-6-2': PageURLs.ofRoleManagement(),
  '4-6-3': PageURLs.ofRoleManagement(),
  '4-6-4': PageURLs.ofRoleManagement(),
  '4-7-1': PageURLs.ofAdminActivityLog(),
  '8-9-1': PageURLs.ofUnitConversion(),
  '8-9-2': PageURLs.ofUnitConversion(),
  '8-9-3': PageURLs.ofUnitConversion(),
  '8-9-4': PageURLs.ofUnitConversion(),
  '8-10-1': PageURLs.ofConclusionRecommendation(),
  '8-10-2': PageURLs.ofConclusionRecommendation(),
  '8-10-3': PageURLs.ofConclusionRecommendation(),
  '8-10-4': PageURLs.ofConclusionRecommendation(),
  '11-12-1': PageURLs.ofHomeBannerSlider(),
  '11-12-2': PageURLs.ofHomeBannerSlider(),
  '11-12-3': PageURLs.ofHomeBannerSlider(),
  '11-12-4': PageURLs.ofHomeBannerSlider(),
  '11-13-1': PageURLs.ofHomeAboutUs(),
  '11-13-2': PageURLs.ofHomeAboutUs(),
  '11-13-3': PageURLs.ofHomeAboutUs(),
  '14-15-1': PageURLs.ofHealthConsultingManagement(),
  '14-15-2': PageURLs.ofHealthConsultingManagement(),
  '14-15-3': PageURLs.ofHealthConsultingManagement(),
  '14-15-4': PageURLs.ofHealthConsultingManagement(),
  '14-16-1': PageURLs.ofFoodManagement(),
  '14-16-2': PageURLs.ofFoodManagement(),
  '14-16-3': PageURLs.ofFoodManagement(),
  '14-16-4': PageURLs.ofFoodManagement(),
  '14-16-5': PageURLs.ofFoodManagement(),
  '14-17-1': PageURLs.ofHealthStatusManagement(),
  '14-17-2': PageURLs.ofHealthStatusManagement(),
  '14-17-3': PageURLs.ofHealthStatusManagement(),
  '14-17-4': PageURLs.ofHealthStatusManagement(),
  '14-18-1': PageURLs.ofProductManagement(),
  '14-18-2': PageURLs.ofProductManagement(),
  '14-18-3': PageURLs.ofProductManagement(),
  '14-18-4': PageURLs.ofProductManagement(),
  '14-19-1': PageURLs.ofDishManagement(),
  '14-19-2': PageURLs.ofDishManagement(),
  '14-19-3': PageURLs.ofDishManagement(),
  '14-19-4': PageURLs.ofDishManagement(),
  '14-20-1': PageURLs.ofAdviceRecommendationManagement(),
  '14-20-2': PageURLs.ofAdviceRecommendationManagement(),
  '14-20-3': PageURLs.ofAdviceRecommendationManagement(),
  '14-20-4': PageURLs.ofAdviceRecommendationManagement(),
  '14-21-1': PageURLs.ofComboFoodManagement(),
  '14-21-2': PageURLs.ofComboFoodManagement(),
  '14-21-3': PageURLs.ofComboFoodManagement(),
  '14-21-4': PageURLs.ofComboFoodManagement(),
  '14-21-5': PageURLs.ofComboFoodManagement(),
  '14-22-1': PageURLs.ofNutritionStandardsManagement(),
  '14-22-2': PageURLs.ofNutritionStandardsManagement(),
  '14-22-3': PageURLs.ofNutritionStandardsManagement(),
  '14-22-4': PageURLs.ofNutritionStandardsManagement(),
  '14-22-5': PageURLs.ofNutritionStandardsManagement(),
  '14-23-1': PageURLs.ofNutritionalMenuCalculatorManagement(),
  '14-23-2': PageURLs.ofNutritionalMenuCalculatorManagement(),
  '14-23-3': PageURLs.ofNutritionalMenuCalculatorManagement(),
  '14-23-4': PageURLs.ofNutritionalMenuCalculatorManagement(),
  '26-27-1': PageURLs.ofChatGPT(),
  '26-27-2': PageURLs.ofChatGPT(),
  '26-27-3': PageURLs.ofChatGPT(),
  '26-27-4': PageURLs.ofChatGPT(),
  '26-28-1': PageURLs.ofHistoryChatBox(),
  '26-28-2': PageURLs.ofHistoryChatBox(),
  '26-28-3': PageURLs.ofHistoryChatBox(),
  '26-28-4': PageURLs.ofHistoryChatBox(),
  '26-29-1': PageURLs.ofUploadKeyAndConfig(),
  '26-29-2': PageURLs.ofUploadKeyAndConfig(),
  '26-29-3': PageURLs.ofUploadKeyAndConfig(),
  '26-29-4': PageURLs.ofUploadKeyAndConfig(),
  '15-24-1': PageURLs.ofNotificationManagement(),
  '15-24-2': PageURLs.ofNotificationManagement(),
  '15-24-3': PageURLs.ofNotificationManagement(),
  '15-24-4': PageURLs.ofNotificationManagement(),
  '11-25-1': PageURLs.ofHomeBannerHeader(),
  '11-25-2': PageURLs.ofHomeBannerHeader(),
  '11-25-3': PageURLs.ofHomeBannerHeader(),
  '11-25-4': PageURLs.ofHomeBannerHeader()
};

export const PERMISSION_WHITE_LIST = [
  '/',
  '/404',
  '/403',
  '/login',
  `${PageURLs.ofNotificationManagement()}`
];
